module.exports = __webpack_public_path__ + "static/media/ky.33156830.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ky.svg
// module id = 169
// module chunks = 0